import { createValidator, empty, ErrorObject, range, required } from 'util/validation'

import {
  AcompanhamentoCondicaoSaudeFiltrosAvancadosModel,
  AcompanhamentoCondicaoSaudeFormModel,
  TipoVulnerabilidadeEnum,
} from './model/model-acompanhamentoCondicaoSaude'

export const acompanhamentoCondicaoSaudeValidator = createValidator<AcompanhamentoCondicaoSaudeFormModel>(
  {
    equipeResponsavel: required,
  },
  (values: AcompanhamentoCondicaoSaudeFormModel, errors: ErrorObject<AcompanhamentoCondicaoSaudeFormModel>) => {
    const { tipoVulnerabilidadeSelected, tria } = values

    if (tipoVulnerabilidadeSelected === TipoVulnerabilidadeEnum.TRIA) {
      errors.tria = {
        periodoRegistro: required(tria?.periodoRegistro),
        resultadosTria: required(tria?.resultadosTria),
      }
    }

    return errors
  }
)

export const acompanhamentoCondicaoSaudeFiltrosAvancadosValidator = createValidator<
  AcompanhamentoCondicaoSaudeFiltrosAvancadosModel
>(
  {},
  (
    values: AcompanhamentoCondicaoSaudeFiltrosAvancadosModel,
    errors: ErrorObject<AcompanhamentoCondicaoSaudeFiltrosAvancadosModel>
  ) => {
    if (values.ivcf?.exibirApenasCidadaosIdososSemIvcf) {
      errors.ivcf = {
        pontuacao: empty(values.ivcf?.pontuacao),
        riscoVulnerabilidade: empty(values.ivcf?.riscoVulnerabilidade),
        subgrupo: empty(values.ivcf?.subgrupo),
      }
    } else {
      errors.ivcf = {
        pontuacao:
          range(0, 40)(values.ivcf?.pontuacao?.firstValue) || range(0, 40)(values.ivcf?.pontuacao?.secondValue),
      }

      return errors
    }
  }
)
